var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 264,
    viewBox: "0 0 196 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 264,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8677 139.838C103.359 139.838 106.779 141.23 109.229 144.014C114.129 149.634 114.231 160.875 109.127 166.753C106.626 169.641 103.053 171.136 98.3573 171.136H84.6271V139.838H98.8677ZM192.427 54.1406L142.406 3.60938C140.109 1.28906 136.996 0 133.729 0H130.667V66H196V62.8547C196 59.6063 194.724 56.4609 192.427 54.1406ZM114.333 70.125V0H12.25C5.46146 0 0 5.51719 0 12.375V251.625C0 258.483 5.46146 264 12.25 264H183.75C190.539 264 196 258.483 196 251.625V82.5H126.583C119.846 82.5 114.333 76.9312 114.333 70.125ZM141.385 155.306C141.385 201.867 96.0604 195.319 84.6781 195.319V224.812C84.6781 228.216 81.9219 231 78.5531 231H62.8323C59.4635 231 56.7073 228.216 56.7073 224.812V121.791C56.7073 118.387 59.4635 115.603 62.8323 115.603H104.176C126.89 115.603 141.385 132.516 141.385 155.306Z",
    fill: "#FB8700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 264,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/ppt-icon.81c091a27214c5ba2edbacb7df8ec1fa.svg";
export { ForwardRef as ReactComponent };